import React, { useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities as getCompanies, getLoggedCompany } from 'app/entities/company/company.reducer';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { SchedulingTruckListModal } from 'app/modules/scheduling/schedulingTruckListModal';
import { SchedulingUserListModal } from 'app/modules/scheduling/schedulingUserListModal';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { BoxForm, FormControlDefault, MenuItemStyled, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { DaysOfWeek } from 'app/shared/model/enumerations/daysOfWeek.model';
import { SchedulingMethod } from 'app/shared/model/enumerations/scheduling-method.model';
import { Status } from 'app/shared/model/enumerations/scheduling-status.model';
import { SchedulingType } from 'app/shared/model/enumerations/scheduling-type.model';
import { IScheduling } from 'app/shared/model/scheduling.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { IUser } from 'app/shared/model/user.model';
import { convertDateTimeToServer } from 'app/shared/util/date-utils';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { createEntity, createRecurringScheduling, getEntity, reset, updateEntity } from './scheduling.reducer';

const schedulingType: SchedulingType[] = [SchedulingType.LAUNCH_DAILY, SchedulingType.PERIOD, SchedulingType.RECURRENT];
const schedulingMethod: SchedulingMethod[] = [SchedulingMethod.UNIQUE, SchedulingMethod.RETROACTIVE];
const daysOfWeek: DaysOfWeek[] = [
  DaysOfWeek.MONDAY,
  DaysOfWeek.TUESDAY,
  DaysOfWeek.WEDNESDAY,
  DaysOfWeek.THURSDAY,
  DaysOfWeek.FRIDAY,
  DaysOfWeek.SATURDAY,
  DaysOfWeek.SUNDAY,
];
const schedulingStatus: Status[] = [Status.SCHEDULED, Status.INTRANSIT, Status.COMPLETED, Status.CANCELED];

export const SchedulingUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const isTransporterAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.TRANSPORTER_ADMIN]));
  const isTransporterManager = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.TRANSPORTER_MANAGER]));
  const isManufacturerAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.MANUFACTURER_ADMIN]));
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));

  const updateSuccess = useAppSelector(state => state.scheduling.updateSuccess);
  const schedulingEntity = useAppSelector(state => state.scheduling.entity);
  const loading = useAppSelector(state => state.scheduling.loading);
  const inputRef = React.useRef(null);

  const [selectedTruckImplement, setSelectedTruckImplement] = useState<ITruckImplement>(null);
  const [selectedDaysOfWeek, setSelectedDaysOfWeek] = useState<DaysOfWeek[]>([]);
  const [modalOpenTruckImplement, setModalOpenTruckImplement] = useState(false);
  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const [selectedUser, setSelectedUser] = useState<IUser>(null);
  const [numberOfWeek, setNumberOfWeek] = useState<number>(0);
  const [modalOpenUser, setModalOpenUser] = useState(false);
  const newUrl = props.location.pathname;
  const [formData, setFormData] = useState({
    id: null,
    company: null,
    description: '',
    endTime: '',
    startTime: '',
    method: '',
    status: '',
    truckImplement: null,
    user: null,
    type: null,
    createdBy: '',
  });

  useEffect(() => {
    !isAdmin && dispatch(getLoggedCompany());
  }, [isAdmin]);

  useEffect(() => {
    if (!isNew && schedulingEntity) {
      setFormData({
        id: schedulingEntity?.id,
        description: schedulingEntity?.description,
        startTime: schedulingEntity?.startTime,
        endTime: schedulingEntity?.endTime,
        method: schedulingEntity?.method,
        status: schedulingEntity?.status,
        truckImplement: schedulingEntity?.truckImplement,
        user: schedulingEntity?.user,
        type: schedulingEntity?.type,
        company: schedulingEntity?.company,
        createdBy: schedulingEntity?.createdBy,
      });
    }
  }, [schedulingEntity]);

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    props.history.replace(newUrl);
  }, [modalOpenTruckImplement, modalOpenUser, setModalOpenTruckImplement, setModalOpenUser, selectedTruckImplement, selectedUser]);

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));

    if (isAdmin || isManufacturerAdmin || isTransporterAdmin || isTransporterManager) {
      dispatch(getUsers({}));
    }
    if (isAdmin) {
      dispatch(getCompanies({}));
    }
  }, []);

  useEffect(() => {
    if (selectedTruckImplement) {
      setFormData({ ...formData, truckImplement: selectedTruckImplement });
    }
  }, [selectedTruckImplement]);

  useEffect(() => {
    if (selectedUser) {
      setFormData({ ...formData, user: selectedUser });
    }
  }, [selectedUser]);

  const handleClose = () => {
    props.history.push('/scheduling' + props.location.search);
  };

  const saveEntity = values => {
    const entity = {
      ...schedulingEntity,
      ...values,
      company: isAdmin ? values.company : null,
      status: isNew ? 'SCHEDULED' : values.status,
      startTime: convertDateTimeToServer(values.startTime),
      endTime: convertDateTimeToServer(values.endTime),
    };

    if (!entity.truckImplement?.id) {
      return toast.error('Necessário selecionar um ativo.');
    }
    if (isAdmin || isManufacturerAdmin || isTransporterAdmin || isTransporterManager) {
      if (!entity.user?.id) {
        return toast.error('Necessário selecionar um motorista.');
      }
    }
    if (entity.startTime === null || entity.endTime === null) {
      return toast.error('Necessário informar a Data e Hora inicial e final.');
    }
    if (entity.startTime >= entity.endTime) {
      return toast.error('A Data e Hora inicial não pode ser maior ou igual a final.');
    }
    if (entity.type === 'RECURRENT' && selectedDaysOfWeek.length === 0 && isNew) {
      return toast.error('Necessário selecionar ao menos um dia da semana.');
    }
    if (entity.type === 'RECURRENT' && numberOfWeek === 0 && isNew) {
      return toast.error('Necessário informar a quantidade de semanas.');
    }
    if (entity.type === 'RECURRENT' && numberOfWeek >= 13) {
      return toast.error('Só é permitido agendar até 12 semanas consecutivas.');
    }
    if (entity.type === 'RECURRENT' && entity.method === 'RETROACTIVE') {
      return toast.error('Não é permitido agendar recorrência retroativa.');
    }

    const handleEntityDispatch = async (entityParam: IScheduling, isNewParam: boolean) => {
      if (formData.type === 'RECURRENT' && isNewParam) {
        try {
          const action = createRecurringScheduling({
            entity: entityParam,
            daysOfWeek: selectedDaysOfWeek,
            numberOfWeek,
          });
          dispatch(action);
          console.log('Recurrence scheduling dispatched successfully');
        } catch (error) {
          console.error('Error dispatching recurrence scheduling:', error);
        }
      } else {
        try {
          const action = isNewParam ? createEntity(entityParam) : updateEntity(entityParam);
          await dispatch(action);
        } catch (error) {
          console.error('Error when dealing with entity:', error);
        }
      }
    };
    handleEntityDispatch(entity, isNew);
  };
  const handleSubmit = () => {
    event.preventDefault();
    saveEntity(formData);
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleDaysOfWeek = (day: DaysOfWeek) => {
    if (selectedDaysOfWeek.includes(day)) {
      setSelectedDaysOfWeek(selectedDaysOfWeek.filter(d => d !== day));
    } else {
      setSelectedDaysOfWeek([...selectedDaysOfWeek, day]);
    }
  };

  const handleNumberOfWeek = numbers => {
    setNumberOfWeek(numbers);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <RegisterLayout>
          <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
            <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.truckImplement'} />
            <Box>
              {loading ? (
                <Box>
                  <Typography>Loading...</Typography>
                </Box>
              ) : (
                <Box margin={'0 auto'} width={'100%'}>
                  <BoxForm onSubmit={handleSubmit}>
                    <FormControlDefault variant={'outlined'} sx={{ height: '110px', mb: 3 }}>
                      <TypographyForms>{translate('fleetSenseApp.scheduling.description')}</TypographyForms>
                      <TextFieldForms
                        multiline
                        rows={4}
                        sx={{
                          height: '112px !important',
                          '& .MuiOutlinedInput-root': {
                            height: '100% !important',
                          },
                          mb: 2,
                        }}
                        value={formData['description']}
                        id={'scheduling-description'}
                        data-cy={'description'}
                        name={'description'}
                        required={true}
                        onChange={e => handleInputChange('description', e.target.value)}
                      />
                    </FormControlDefault>
                    <FormControlDefault>
                      <TypographyForms>{translate('fleetSenseApp.scheduling.method')}</TypographyForms>
                      <TextFieldForms
                        value={formData['method'] || ''}
                        onChange={event => handleInputChange('method', event.target.value)}
                        select
                        name={'method'}
                        data-cy={'method'}
                        required={true}
                      >
                        {schedulingMethod &&
                          schedulingMethod.map(method => (
                            <MenuItemStyled value={method} key={method}>
                              {translate(`fleetSenseApp.SchedulingMethod.${method}`)}
                            </MenuItemStyled>
                          ))}
                      </TextFieldForms>
                    </FormControlDefault>
                    <FormControlDefault>
                      <TypographyForms>{translate('fleetSenseApp.scheduling.type')}</TypographyForms>
                      <TextFieldForms
                        value={formData['type'] || ''}
                        onChange={event => handleInputChange('type', event.target.value)}
                        select
                        name={'type'}
                        data-cy={'type'}
                        required={true}
                      >
                        {schedulingType &&
                          schedulingType.map(type => (
                            <MenuItemStyled value={type} key={type}>
                              {translate(`fleetSenseApp.SchedulingTypes.${type}`)}
                            </MenuItemStyled>
                          ))}
                      </TextFieldForms>
                    </FormControlDefault>
                    {isNew && formData.type === 'RECURRENT' && (
                      <>
                        <FormControlDefault>
                          <TypographyForms>{translate('fleetSenseApp.scheduling.daysOfWeek')}</TypographyForms>
                          <Box sx={{ display: 'flex', width: '100%' }}>
                            {daysOfWeek &&
                              daysOfWeek.map(days => (
                                <Box
                                  key={days}
                                  sx={{
                                    width: '15vw',
                                    borderRadius: '8px',
                                    cursor: 'pointer !important',
                                    margin: '2px',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: '1px solid',
                                    padding: '5px',
                                    borderColor: selectedDaysOfWeek.includes(days) ? 'secondary.main' : 'primary.light',
                                    backgroundColor: selectedDaysOfWeek.includes(days) ? 'secondary.main' : 'primary.main',
                                  }}
                                  onClick={event => handleDaysOfWeek(days)}
                                >
                                  <Box display={'flex'} justifyContent={'center'}>
                                    <Typography
                                      sx={{
                                        color: selectedDaysOfWeek.includes(days) ? 'secondary.contrastText' : 'text.primary',
                                        fontWeight: selectedDaysOfWeek.includes(days) ? 'bold' : 'normal',
                                      }}
                                    >
                                      {translate(`fleetSenseApp.daysOfWeek.${days}`)}
                                    </Typography>
                                  </Box>
                                </Box>
                              ))}
                          </Box>
                        </FormControlDefault>

                        <FormControlDefault>
                          <TypographyForms>{translate('fleetSenseApp.scheduling.numbersOfWeek')}</TypographyForms>
                          <TextFieldForms
                            value={numberOfWeek || ''}
                            onChange={event => handleNumberOfWeek(event.target.value)}
                            placeholder={translate('fleetSenseApp.scheduling.placeholderNumbersOfWeek')}
                            name={'numberOfWeek'}
                            data-cy={'numberOfWeek'}
                            required={isNew ? true : false}
                            type={'number'}
                          ></TextFieldForms>
                        </FormControlDefault>
                      </>
                    )}
                    <FormControlDefault>
                      <TypographyForms>{translate('fleetSenseApp.scheduling.startTime')}</TypographyForms>
                      <LocalizationProvider label="Responsive variant" dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          value={formData['startTime']}
                          disablePast={formData.method === 'RETROACTIVE' ? false : true}
                          ampm={false}
                          onChange={dateTime => handleInputChange('startTime', dateTime)}
                          renderInput={params => <TextFieldForms {...params} inputRef={inputRef} />}
                          PopperProps={{
                            anchorEl: inputRef?.current?.nextSibling,
                            placement: 'top-start',
                          }}
                        />
                      </LocalizationProvider>
                    </FormControlDefault>
                    <FormControlDefault>
                      <TypographyForms>{translate('fleetSenseApp.scheduling.endTime')}</TypographyForms>
                      <LocalizationProvider label="Responsive variant" dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          value={formData['endTime']}
                          disablePast={formData.method === 'RETROACTIVE' ? false : true}
                          minDate={formData.type !== 'PERIOD' ? dayjs(formData['startTime']).startOf('day') : undefined}
                          maxDate={formData.type !== 'PERIOD' ? dayjs(formData['startTime']).startOf('day') : undefined}
                          ampm={false}
                          onChange={dateTime => handleInputChange('endTime', dateTime)}
                          renderInput={params => <TextFieldForms {...params} inputRef={inputRef} />}
                          PopperProps={{
                            anchorEl: inputRef?.current?.nextSibling,
                            placement: 'top-start',
                          }}
                        />
                      </LocalizationProvider>
                    </FormControlDefault>
                    <FormControlDefault>
                      <TypographyForms>{translate('fleetSenseApp.scheduling.truckImplement')}</TypographyForms>
                      <TextFieldForms
                        value={formData['truckImplement']?.licensePlate || ''}
                        required
                        sx={{ cursor: 'pointer !important' }}
                        id="scheduling-Truckmplement"
                        name="truckImplementList"
                        onClick={() => setModalOpenTruckImplement(true)}
                        placeholder={translate('fleetSenseApp.scheduling.choseTruck')}
                      />
                    </FormControlDefault>
                    {(isAdmin || isManufacturerAdmin || isTransporterAdmin || isTransporterManager) && (
                      <FormControlDefault>
                        <TypographyForms>{translate('fleetSenseApp.scheduling.user')}</TypographyForms>
                        <TextFieldForms
                          value={formData['user']?.firstName === undefined ? '' : `${formData['user']?.firstName}  ${formData['user']?.lastName}`}
                          required
                          sx={{ cursor: 'pointer !important' }}
                          id="scheduling-user"
                          name="userList"
                          onClick={() => setModalOpenUser(true)}
                          placeholder={translate('fleetSenseApp.scheduling.choseUser')}
                        />
                      </FormControlDefault>
                    )}
                    {modalOpenTruckImplement && (
                      <SchedulingTruckListModal
                        props={props}
                        setModalOpen={setModalOpenTruckImplement}
                        selectedTruckImplement={selectedTruckImplement}
                        setSelectedTruckImplement={setSelectedTruckImplement}
                      />
                    )}
                    {modalOpenUser && (
                      <SchedulingUserListModal props={props} setModalOpen={setModalOpenUser} selectedUser={selectedUser} setSelectedUser={setSelectedUser} />
                    )}
                    {!isNew && (
                      <FormControlDefault>
                        <TypographyForms>{translate('fleetSenseApp.scheduling.status')}</TypographyForms>
                        <TextFieldForms
                          value={formData['status'] || ''}
                          onChange={event => handleInputChange('status', event.target.value)}
                          select
                          name={'status'}
                          data-cy={'status'}
                          required={true}
                        >
                          {schedulingStatus &&
                            schedulingStatus.map(status => (
                              <MenuItemStyled value={status} key={status}>
                                {translate(`fleetSenseApp.SchedulingStatus.${status}`)}
                              </MenuItemStyled>
                            ))}
                        </TextFieldForms>
                      </FormControlDefault>
                    )}
                    {isAdmin && (
                      <FormControlDefault>
                        <SelectPaginate
                          label={translate('fleetSenseApp.userCustom.company')}
                          apiUrl={'api/companies'}
                          onChange={value => handleInputChange('company', value)}
                          value={formData['company']}
                          valueName="name"
                          icon="sort-down"
                          isRequired={true}
                          filterStyle={true}
                        />
                      </FormControlDefault>
                    )}
                    <RegisterButton />
                  </BoxForm>
                </Box>
              )}
            </Box>
          </Box>
        </RegisterLayout>
      </ThemeProvider>
    </>
  );
};
